import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ClientDetailInfo = lazy(
  () => import('@components/Client/ClientDetailInfo')
);

/** 마스터 계정 > 회사 관리 > 상세 */
const ClientDetail = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ClientDetailInfo />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default ClientDetail;
